<ng-template #template>
  <soft-remote-data-container [data]="data()"
                              [loadingState]="loadingState()"
                              [loadingError]="loadingError()">
    <ng-content></ng-content>
  </soft-remote-data-container>
</ng-template>
